import React from "react";
import { getField } from "../../util/DynamicItemUtils";

export default function RulemakingDocket({ item }: any) {
  return (
    <div>
      <p className="lead-text-lt">Rulemaking Docket</p>
      <h3>
        <a href={getField(item, "docketcontentpage").replace("~", "")}>
          {getField(item, "title")}
        </a>
      </h3>
      <div className="hawk-row">
        {getField(item, "docketstatus") && (
          <div className="hawk-column">
            <div className="lead-text-lt">Status</div>
            <div className="lead-text-st">{getField(item, "docketstatus")}</div>
          </div>
        )}
      </div>
      <a
        href={getField(item, "docketcontentpage").replace("~", "")}
        className="hawk-read-more"
      >
        Read More
      </a>
    </div>
  );
}
